import {
  IconAddressBook,
  IconBuilding,
  IconCertificate,
  IconFileDescription,
  IconFileText,
  IconList,
  IconPhoto,
  IconPhotoEdit,
  IconSettings,
  IconShieldCheck,
  IconSparkles,
  IconTemplate,
  IconTool,
  IconUsers,
  IconWorld,
} from '@tabler/icons-react';
import type { ReactNode } from 'react';

/** Ikona skupine nastavitev v levem meniju po ključu skupine (vsaka skupina mora imeti svojo – preveri test). */
export const IKONE: Record<string, ReactNode> = {
  podjetje: <IconBuilding size={18} />,
  naslov: <IconAddressBook size={18} />,
  splosno: <IconSettings size={18} />,
  dokumenti: <IconFileText size={18} />,
  delavnica: <IconTool size={18} />,
  logotip: <IconPhoto size={18} />,
  predloge: <IconTemplate size={18} />,
  sifranti: <IconList size={18} />,
  furs: <IconCertificate size={18} />,
  uporabniki: <IconUsers size={18} />,
  vloge: <IconShieldCheck size={18} />,
  'javna-ponudba': <IconWorld size={18} />,
  'opis-vozil': <IconFileDescription size={18} />,
  'umetna-inteligenca': <IconSparkles size={18} />,
  'urejanje-slik': <IconPhotoEdit size={18} />,
};
